import { createFileRoute } from "@tanstack/react-router";

import { ComparisonsPage } from "./comparisons.index";

export const Route = createFileRoute("/revPilot/")({
  component: RevPilotPage,
});

export function RevPilotPage() {
  return <ComparisonsPage />;
}
